import layoutHelpers from '@/layout/helpers.js'

export default function () {
  return {
    // Public url
    publicUrl: process.env.BASE_URL,
    // Layout helpers
    layoutHelpers,

    get datetimeConfig () {
      return {
        enableTime: true,
        altInput: true,
        allowInput: true,
        minuteIncrement: 15,
        time_24hr: true,
        dateFormat: 'Z',
        altFormat: 'd-m-y H:i'
      }
    },

    get dateConfig () {
      return {
        altInput: true,
        allowInput: true,
        minuteIncrement: 15,
        dateFormat: 'Z',
        altFormat: 'd-m-y'
      }
    },

    get timeConfig () {
      return {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'Z',
        time_24hr: true,
        altInput: true,
        allowInput: true,
        altFormat: 'H:i',
        minuteIncrement: 5
      }
    },

    get getYilNumber () {
      return parseInt(this.getYil, 10)
    },
    get getYil () {
      if (this.proje2026Mi) {
        return '2026'
      }
      if (this.proje2025Mu) {
        return '2025'
      }
      if (this.proje2024Mu) {
        return '2024'
      }
      if (this.proje2023Mu) {
        return '2023'
      }
      if (this.proje2022Mi) {
        return '2022'
      }
      return '2021'
    },

    get proje2021Mi () {
      return window.location.host === '2021-yazokulu.hayrategitim.com'
    },

    get proje2022Mi () {
      return window.location.host === '2022-yazokulu.hayrategitim.com'
    },

    get proje2023Mu () {
      return window.location.host === '2023-yazokulu.hayrategitim.com'
    },

    get proje2024Mu () {
      return window.location.host === '2024-yazokulu.hayrategitim.com'
    },

    get proje2025Mu () {
      return window.location.host === '2025-yazokulu.hayrategitim.com'
    },

    get proje2026Mi () {
      return window.location.host === 'yazokulu.hayrategitim.com' ||
      window.location.host === 'localhost:8080'
    },

    get projeBilecikMi () {
      return window.location.host === 'bilecik.kuranogren.com'
    },

    get isActiveYear () {
      return this.proje2026Mi
    },

    get link () {
      return window.location.origin
    },
    // Check for RTL layout
    get isRtlMode () {
      return document.documentElement.getAttribute('dir') === 'rtl' ||
                document.body.getAttribute('dir') === 'rtl'
    },

    // Check if IE
    get isIEMode () {
      return typeof document.documentMode === 'number'
    },

    // Check if IE10
    get isIE10Mode () {
      return this.isIEMode && document.documentMode === 10
    },

    // Layout navbar color
    get layoutNavbarBg () {
      return 'navbar-theme'
    },

    // Layout sidenav color
    get layoutSidenavBg () {
      return 'sidenav-theme'
    },

    // Layout footer color
    get layoutFooterBg () {
      return 'footer-theme'
    },

    // Animate scrollTop
    scrollTop (to, duration, element = document.scrollingElement || document.documentElement) {
      if (element.scrollTop === to) return
      const start = element.scrollTop
      const change = to - start
      const startDate = +new Date()

      // t = current time; b = start value; c = change in value; d = duration
      const easeInOutQuad = (t, b, c, d) => {
        t /= d / 2
        if (t < 1) return c / 2 * t * t + b
        t--
        return -c / 2 * (t * (t - 2) - 1) + b
      }

      const animateScroll = () => {
        const currentDate = +new Date()
        const currentTime = currentDate - startDate
        element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration))
        if (currentTime < duration) {
          requestAnimationFrame(animateScroll)
        } else {
          element.scrollTop = to
        }
      }

      animateScroll()
    },
    okulTuruGetir (sinif) {
      if (sinif === '1. Sınıf' || sinif === '2. Sınıf' || sinif === '3. Sınıf' || sinif === '4. Sınıf') {
        return 'İlkokul'
      }
      if (sinif === '5. Sınıf' || sinif === '6. Sınıf' || sinif === '7. Sınıf' || sinif === '8. Sınıf') {
        return 'Ortaokul'
      }
      if (sinif === '9. Sınıf' || sinif === '10. Sınıf' || sinif === '11. Sınıf' || sinif === '12. Sınıf') {
        return 'Lise'
      }
      if (sinif === 'Üniversite 1' || sinif === 'Üniversite 2' || sinif === 'Üniversite 3' ||
          sinif === 'Üniversite 4' || sinif === 'Üniversite 5' || sinif === 'Üniversite 6') {
        return 'Üniversite'
      }
      return ''
    }
  }
}
